import { useQuery } from "@tanstack/react-query"
import {
  listPluginKinds,
  listPlugins,
  listPluginEnvironments
} from "sdk/plugins"

export const pluginKeys = {
  all: ["plugins"],
  list: (...params) => [...pluginKeys.all, ...params],
  detail: id => [...pluginKeys.all, id]
}

export const pluginKindKeys = {
  all: ["pluginKinds"],
  list: (...params) => [...pluginKindKeys.all, ...params],
  detail: id => [...pluginKindKeys.all, id]
}

export function useListPluginKinds() {
  return useQuery({
    queryKey: pluginKindKeys.list(),
    queryFn: listPluginKinds
  })
}

export function useListPluginEnvironments() {
  return useQuery({
    queryKey: pluginKindKeys.list(),
    queryFn: listPluginEnvironments
  })
}

export function useMediaGalleryPlugins(options = {}) {
  return useQuery({
    queryKey: pluginKeys.list({ kind: "media_gallery" }),
    queryFn: () => listPlugins({ kind: "media_gallery" }),
    ...options
  })
}

export function useRuleTriggerPlugins(options = {}) {
  return useQuery({
    queryKey: pluginKeys.list({ kind: "rule_triggers" }),
    queryFn: () => listPlugins({ kind: "rule_triggers" }),
    ...options
  })
}

// Both VA hooks accept an optional `queryParams` bag merged into the request
// (and the cache key), e.g. `{ include_uninstalled: true, per_page: 100 }` for
// the v2 palette. Callers that omit it — the legacy builder's pickers — keep
// the installed-only default.
export function useVaEventPlugins({ queryParams, ...options } = {}) {
  const params = { kind: "va_events", ...queryParams }
  return useQuery({
    queryKey: pluginKeys.list(params),
    queryFn: () => listPlugins(params),
    ...options
  })
}

export function useVaActionPlugins({ queryParams, ...options } = {}) {
  const params = { kind: "va_actions", ...queryParams }
  return useQuery({
    queryKey: pluginKeys.list(params),
    queryFn: () => listPlugins(params),
    ...options
  })
}
